import script from "./AlertsFeedTab.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertsFeedTab.vue?vue&type=script&setup=true&lang=js"

import "./AlertsFeedTab.vue?vue&type=style&index=0&id=46f3fd08&lang=scss"

const __exports__ = script;

export default __exports__